<template>
  <div>
    <v-card
      class="mx-auto"
      height="100"
      max-width="200"
      outlined
    ></v-card>
    <v-card
      class="mt-n12 mx-auto"
      elevation="12"
      height="200"
      max-width="300"
    ></v-card>
  </div>
</template>

<script>
  export default {
    data: () => ({
      //
    }),
  }
</script>
